import { defineAsyncComponent } from 'vue'
export default {
  "blog-post": defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/BlogPost.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/Default.vue").then(m => m.default || m)),
  guest: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/Guest.vue").then(m => m.default || m)),
  settings: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/Settings.vue").then(m => m.default || m))
}